import { Form } from 'antd';
import { FormCreateOption } from 'antd/lib/form';

const create = <T=any>(options?: FormCreateOption<T>): any => {
    return (dom): any => {
        return Form.create(options as any)(dom);
    };
};

export {
    create
};


// WEBPACK FOOTER //
// ./src/node_modules/kts-scaffold-framework/utils/form/index.ts